export default "__VITE_PUBLIC_ASSET__a9b400f5__"